import React from 'react';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Contact = () => {
  return (
    <footer
      style={{
        width: '100%',
        backgroundColor: '#1e1e2f',
        color: '#f8f9fa',
        padding: '20px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <h2 style={{ fontSize: '1.5rem', marginBottom: '10px', color: '#4dd0e1' }}>
        Contact Me
      </h2>
      <p style={{ margin: '5px 0', fontSize: '1rem' }}>Email: trivedi.bh@northeastern.edu</p>
      <p style={{ margin: '5px 0', fontSize: '1rem' }}>Phone: +1 857-800-4279</p>

      <div style={{ marginTop: '15px', display: 'flex', gap: '15px' }}>
        {/* GitHub */}
        <a
          href="https://github.com/Bhagyatrivedi27"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: '1.5rem',
            color: '#f8f9fa',
            textDecoration: 'none',
          }}
        >
          <FaGithub />
        </a>
        {/* LinkedIn */}
        <a
          href="https://linkedin.com/in/bhagyatrivedi27"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: '1.5rem',
            color: '#f8f9fa',
            textDecoration: 'none',
          }}
        >
          <FaLinkedin />
        </a>
        {/* Instagram */}
        <a
          href="https://instagram.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontSize: '1.5rem',
            color: '#f8f9fa',
            textDecoration: 'none',
          }}
        >
          <FaInstagram />
        </a>
      </div>

      <p style={{ marginTop: '20px', fontSize: '0.9rem', color: '#aaaaaa' }}>
        © {new Date().getFullYear()} Bhagya. All rights reserved.
      </p>
    </footer>
  );
};

export default Contact;
